import { gql } from '@apollo/client'

export const ADD_PREMIUM_FREE_SUBSCRIPTION = gql`
  mutation addPremiumFreeSubscription($tenantId: ID!) {
    addPremiumFreeSubscription(tenantId: $tenantId)
  }
`
